module.exports = __webpack_public_path__ + "img/logo-ai-dark-mode.1da52528.svg";